import { render, staticRenderFns } from "./HarmonizedSummary.vue?vue&type=template&id=132e0b5e&scoped=true&"
import script from "./HarmonizedSummary.vue?vue&type=script&lang=js&"
export * from "./HarmonizedSummary.vue?vue&type=script&lang=js&"
import style0 from "./HarmonizedSummary.vue?vue&type=style&index=0&id=132e0b5e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132e0b5e",
  null
  
)

export default component.exports